import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#1a1a1a] py-10 md:py-12"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">
          <span className="text-[#ff4500]">●</span>
          <span>© {year} Tico Moraes — {t.footer.rights}</span>
        </div>
        <div className="flex items-center gap-6 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">
          <span>{t.footer.designedIn}</span>
          <a
            href="https://www.studionuts.com.br"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-studionuts-link"
            className="hover:text-[#ff4500] transition-colors"
          >
            studionuts.com.br ↗
          </a>
        </div>
      </div>
    </footer>
  );
}
